
// import * as Lex from './../service/lex/main';
// const getValidOuterToken = (Lex && Lex.getValidOuterToken) || (Lex && Lex.default && Lex.default.getValidOuterToken);
/* const PRED_HOSTNAME = 'localhost';
const isPredSite = window.location.hostname === PRED_HOSTNAME; */

/* const PRED_PATHNAME = '/diagnostics/prerun-test-irtech';
export const isPredSite = (pathname = window.location.pathname) => {
    return pathname === PRED_PATHNAME;
}; */

/* const PRED_PATHNAMES = [
    '/diagnostics/prerun-test-irtech'
];
export const isPredSite = (pathname = window.location.pathname) => {
    return PRED_PATHNAMES.includes(pathname);
}; */

// export const isPredSite = (pathname = window.location.pathname) => {
//     const outerToken = getValidOuterToken();
//     return !!outerToken;
// };

import { getValidOuterToken } from './../service/lex/main';

export const isPredSite = (pathname = window.location.pathname) => {
  const outerToken = typeof getValidOuterToken === 'function' ? getValidOuterToken() : null;
  return !!outerToken;
};